import React from 'react';
import Main from './main.js'
import './Style.css'
import './App.css';


function App() {
    return (
        <Main />
    );
}

export default App
